export enum WEBHOOK_EVENT_STATUS {
    PENDING = 'pending',
    SENDING = 'sending',
    DELIVERED = 'delivered',
    FAILED = 'failed',
    EXHAUSTED = 'exhausted',
}

export type WebhookEvent = {
    id: string;
    endpoint: {
        id: string;
        url: string;
    };
    topic: string;
    payload: any;
    webhook_id: string;
    status: WEBHOOK_EVENT_STATUS;
    http_status_code: number | null;
    response_body: string;
    attempt_count: number;
    next_retry_at: string | null;
    last_attempted_at: string | null;
    created_at: string;
    modified_at: string;
};
